/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadStageCount
 */
export interface LeadStageCount {
    /**
     * Review Stage (lead status) id for this cell; null when the lead has no review stage.
     */
    status_id?: string;
    /**
     * Admission status value for this cell; null when the lead has no admission status.
     */
    admission_status?: string;
    /**
     * Number of individual leads (not duplicate groups) in this cell.
     */
    count: number;
}

/**
 * Check if a given object implements the LeadStageCount interface.
 */
export function instanceOfLeadStageCount(value: object): value is LeadStageCount {
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function LeadStageCountFromJSON(json: any): LeadStageCount {
    return LeadStageCountFromJSONTyped(json, false);
}

export function LeadStageCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadStageCount {
    if (json == null) {
        return json;
    }
    return {
        
        'status_id': json['status_id'] == null ? undefined : json['status_id'],
        'admission_status': json['admission_status'] == null ? undefined : json['admission_status'],
        'count': json['count'],
    };
}

export function LeadStageCountToJSON(json: any): LeadStageCount {
    return LeadStageCountToJSONTyped(json, false);
}

export function LeadStageCountToJSONTyped(value?: LeadStageCount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status_id': value['status_id'],
        'admission_status': value['admission_status'],
        'count': value['count'],
    };
}

